// src/content/explore/articles.js
// Require context for dynamic imports
const articlesContext = require.context('./', true, /metadata\.json$/);

const articles = articlesContext.keys().map((key) => {
  const meta = articlesContext(key).default || articlesContext(key);
  const articleId = key.replace('./', '').split('/')[0];
  return {
    ...meta,
    id: articleId,
  };
});

export default articles;